"use strict";
//French
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Contribution',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Sortie',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Annuler',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Sauvegarder',
  'BACK-BTN-LABEL': 'Arrière',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Muet',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Tenir',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Audio',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Acoustique',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Transfert',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'Nouvel Appel',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Raccrocher',
  'CALLLIST-NOCALL' : 'Aucun appel actif',
  'CANCEL-BTN-LABEL' : 'Annuler',
  'EMAIL-PLACEHOLDER' : 'Adresse e-mail',
  'INCOMINGCALL-HEADER' : 'Appel entrant',
  'INCOMINGCALL-ACCEPT' : 'Acceptez',
  'INCOMINGCALL-DECLINE' : 'Déclin',
  'INCOMINGCALL-VOICEMAIL' : 'Envoyer à la messagerie vocale',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' Entrer ladresse e-mail',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'le mot de passe',
  'LOGIN-CHECKBOX-LABEL' : 'Souviens-toi de moi',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Mot de passe oublié?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Se connecter',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Entrez votre adresse e-mail pour réinitialiser votre mot de passe.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Sil vous plaît entrer le mot de passe complet',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Veuillez saisir un email valide',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'les mots de passe doivent correspondre',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'réinitialiser',
  'LOGIN-RESETPW-INFO-TEXT' : ', Sil vous plaît changer votre mot de passe. Mot de passe doit contenir au moins une lettre , pas despace blanc, ne pas commencer par @ et 8 caractères ou plus .',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Nouveau mot de passe',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'Répéter le mot de passe',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Changement',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'Annuler',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Voir Alertes',
  'SETTINGS-VERSION' : 'version ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'Aide Documentation',
  'SETTINGS-CHECKBOX-LABEL' : 'Activer',
  'SETTINGS-CHECKBOX-HEADER' : 'Toujours au top?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Fermer Alertes',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Se déconnecter',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'Extension',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Sonnerie',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Dispositif d\'entrée',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Dispositif de sortie',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Thème d\'interface',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Langue de l\'interface',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Arrière',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Clair',
  'CALLHISTORY-HEADER' : 'Histoire',
  'CALLHISTORY-NO-HISTORY-MSG' : 'Non Historique des appels',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'Paramètres',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'clair',
  'ALERTLOG-HEADER' : 'Alertes',
  'ALERTLOG-NO-ALERT-MSG' : 'Aucune alerte disponible',
  'UTILITIES-STATUS-ONHOLD' : 'En attente',
  'UTILITIES-STATUS-MUTED' : 'En sourdine',
  'UTILITIES-STATUS-ACTIVE' : 'Actif',
  'UTILITIES-STATUS-DIALING' : 'Composition',
  'ALERTITEM-HEADING-LOGIN' : 'Sidentifier',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'Le nom dutilisateur ou le mot de passe que vous avez tapé est incorrect.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'connexion réseau perdue. Vérifier létat de connexion.',
  'DIALINPUT-PLACEHOLDER-TEXT' : 'Entrez un numéro de téléphone',
  'CALLDETAILS-HOLD' : 'En attente',
  'CALLDETAILS-MUTED': 'En sourdine',
  'CALLLIST-STATUS-ACTIVE': 'actif',
  'CALLLIST-STATUS-DIALING': 'composition',
  'CALLHISTORY-STATUS-FAILED': 'Échoué',
  'HEADING-STATUS-CONNECTED' : 'Connecté',
  'HEADING-STATUS-OFFLINE' : 'Hors ligne',
  'BLIND-BTN-LABEL': 'Aveugle',
  'ATTENDED-BTN-LABEL': 'Assisté',
  'SOFTPHONE-DTMF-COMMANDS': "Entrer un nombre",
  'ARIA-LOGIN-SIGNIN-BTN': "Connectez-vous bouton",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "bouton Mot de passe oublié",
  'ARIA-CANCEL-BTN': "bouton Annuler",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "bouton Réinitialiser le mot de passe",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "Pas maintenant le bouton",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'bouton Précédent',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'bouton Effacer lhistorique',
  'ARIA-SETTINGS-LOGOUT-BTN': "bouton Déconnexion",
  'ARIA-SETTINGS-VIEWALERT-BTN': "bouton Afficher les alertes",
  'ARIA-SETTINGS-HELPDOC-BTN': "Aide bouton documentation",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "bouton Changer de mot de passe",
  'ARIA-BACKSPACE-BTN': 'touche Backspace',
  'ARIA-DIALING-INPUT-FIELD': 'champ de saisie de numérotation',
  'ARIA-HEADER': 'Entête',
  'ARIA-CLEAR-ALERTS-BUTTON': 'bouton Effacer les alertes',
  'ARIA-ALERT-LIST': 'liste dalerte',
  'ARIA-CHECKBOX': 'Checkbox',
  'ARIA-SAVE-BTN': 'bouton Enregistrer',
  'ARIA-INPUT-FIELD': 'Champ de saisie',
  'ARIA-INPUT': 'Contribution',
  'ARIA-KEYPAD': 'Clavier',
  'ARIA-KEY': 'Clé',
  'ARIA-AUDIO-SLIDER': 'curseur Audio',
  'ARIA-AUDIO-SLIDER-CONTROL': 'curseur de contrôle audio',
  'ARIA-MENU-ITEM': 'Élément du menu',
  'ARIA-DROP-DOWN-MENU': 'Menu déroulant',
  'ARIA-BADGE-BUTTON': 'bouton Badge',
  'ARIA-CALL-DETAIL': 'détail Appel',
  'ARIA-OPEN-SETTINGS-BUTTON': 'bouton Ouvrir les paramètres',
  'UPDATE-HEADER': 'Mise à jour disponible',
  'UPDATE-MSG': 'Voulez-vous redémarrer lapplication maintenant?',
  'UPDATE-POSTPONE-BUTTON': 'Différer (1 min)',
  'UPDATE-UPDATE-BUTTON': 'Mettre à jour',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'Différer Bouton',
  'ARIA-UPDATE-UPDATE-BUTTON': 'Mise à jour Bouton',
  'ACTIVECALL-STATUS-RINGING': 'Sonnerie',
  'ACTIVECALL-STATUS-ACTIVE': 'actif',
  'ACTIVECALL-STATUS-DIALING': 'composition',
  'ACTIVECALL-STATUS-FAILED': 'Échoué',
  'LOGIN-INPUT-SHOW': 'Montrer',
  'LOGIN-INPUT-HIDE': 'Cacher',
  'CALLHISTORY-TODAY': 'aujourdhui',
  'CALLHISTORY-YESTERDAY': 'Hier',
  'ALERT_FORGOT_PASSWORD': 'Mot de passe oublié',
  'ALERT_SETTINGS_WILL_APPLY': 'Les appels en cours; les paramètres seront appliqués en cas dinactivité.',
  'ALERT_DIALING_OPTIONS': 'options de numérotation',
  'ALERT_DIALING_OPTIONS_BODY': 'options de plan de numérotation manquant',
  'ALERT_LOGIN': 'Sidentifier',
  'ALERT_SOFTPHONE_EXTENSION': 'Aucune extension softphone',
  'ALERT_MORE_INFORMATION': 'Pour plus dinformations, visitez:',
  'ALERT_LOST_CONNECTION': 'connexion réseau perdue. Vérifier létat de connexion.',
  'ARIA-PLAY-BTN': 'Bouton de lecture',
  'ARIA-STOP-BTN': 'Bouton darrêt',
  'CONTACTS-STATUS-ONLINE': 'En ligne',
  'CONTACTS-STATUS-OFFLINE': 'Hors ligne',
  'CONTACTS-STATUS-BUSY': 'Occupé',
  'CONTACTS-STATUS-UNKNOWN': 'Inconnu',
  'LABELLEDINPUT-LABEL-EMAIL': "Adresse e-mail",
  'LABELLEDINPUT-LABEL-PASSWORD': "Mot de passe",
  'LABELLEDINPUT-LABEL-TEXT': "Texte",
  'LABELLEDINPUT-HINT-EMAIL': "Entrez une adresse e-mail valide ci-dessous.",
  'LABELLEDINPUT-HINT-PASSWORD': "Entrez un mot de passe valide ci-dessous.",
  'LABELLEDINPUT-HINT-TEXT': "Entrez le texte ci-dessous.",
  'ARIA-ICON-AREA': 'Zone des icônes',
  'SETTINGS-ADVANCED-LOGGING': "Enregistrement avancé",
  'APPMENU-SETTINGS-BTN-LABEL': "Paramètres d'ouverture",
  'APPMENU-HELP-BTN-LABEL': "Documentation d'aide",
  'APPMENU-LOGOUT-BTN-LABEL': "Connectez - Out",
  'APPMENU-VERSION': "version ",
  'HEADER-SETTINGS-TITLE': "Paramètres",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Notifications",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Apparence",
  'SETTINGS-CONTACTS-BTN-LABEL': "Contacts",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Dépannage",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Ajustez la façon dont vous recevez les mises à jour.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Changez l'apparence de l'application .",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Importez vos contacts.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Outils pour vous aider à découvrir ce qui ne va pas",
  'ARIA-BACK-BTN-LABEL': "Arrière",
  'HEADER-BACK-ARIA-LABEL' : 'arrière',
  'ENTITYLIST-SEARCH-FOUND': "a trouvé.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "articles",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Nouveau groupe',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'Aucun contact trouvé',
  'ENTITYLIST-TRY-IMPORTING': 'Essayez dimporter ou dajouter un contact.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Importer',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Entrez le numéro pour envoyer ou importer votre liste de contacts dans les paramètres.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Rechercher des contacts",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Ajouter un numéro',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'Aucune information de contact',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Ajouter un numéro pour commencer',
  'ARIA-CARD-DETAILS-EDIT': 'modifier',
  'ARIA-CARD-DETAILS-DELETE': 'Effacer',
  'SETTINGS-DEVICES-BTN-LABEL': "Dispositifs",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Modifier la configuration de vos appareils.",
  'HEADER-CONTACTS-ARIA-LABEL' : "contacts",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Dépannage",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Activer la journalisation avancée",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "Lorsque cette option est activée, l'application crée des journaux avancés pour faciliter le diagnostic des erreurs d'application.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Journalisation avancée',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Alertes",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Afficher les alertes",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Accédez à un enregistrement des alertes et des journaux.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Sonnerie",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Modifier la sonnerie des appels vocaux entrants.",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "Défaut",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Lumière",
  'APPMENU-DARK-THEME-BTN-LABEL': "Foncé",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "Toujours au top",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "Lorsque cette option est activée, l'application s'affiche toujours au-dessus de vos autres applications.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Toujours au top?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "Thème",
  'SETTINGS-THEMES-DESCRIPTION': "Les thèmes changent l'aspect général de l'application.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "La langue",
  'SETTINGS-LANGUAGE-DESCRIPTION': "La modification de la langue change tout au long de l'application.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "Dispositif",
  'SETTINGS-CATEGORY-HEADER-CONTACTS': "Contacts",
  'SETTINGS-CATEGORY-HEADER-APPEARANCE': "Appearance",
  'SETTINGS-CATEGORY-HEADER-NOTIFICATIONS': "Notifications",
  'SETTINGS-INPUT-DEVICE-TITLE': "Dispositif d'entrée",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Réglez le périphérique audio que vous souhaitez utiliser pour l'entrée.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Dispositif de sortie",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Réglez le périphérique audio que vous souhaitez utiliser pour la sortie.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Importer vos contacts",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Sélectionnez votre option ci-dessous pour importer des contacts.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Échantillon CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "En appuyant sur le bouton ci-dessous, vous téléchargerez un exemple de fichier CSV.",
  'SETTINGS-CONTACTS-BACKUP': 'Sauvegarde',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Appuyez sur le bouton ci-dessous pour télécharger une sauvegarde CSV de vos contacts. Ceci est recommandé avant les importations.",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Télécharger l\'exemple',
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Iimporté",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Importer",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Télécharger la sauvegarde',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Ajouter le contact',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Annuler",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Effacer",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Êtes-vous sûr de vouloir supprimer ce contact?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "L'achèvement de cette action supprimera définitivement les informations du contact actuel. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Un champ dans le formulaire ci-dessous présente une erreur.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Informations personnelles',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Prénom',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Entrez votre prénom',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Nom de famille',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Entrez le nom de famille',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Compagnie',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': "Entrez le nom de l'entreprise",
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Les numéros de téléphone',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Ajouter un téléphone',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Annuler',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'sauvegarder',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Nouveau contact',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Modifier le contact',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'Cette case ne peut pas être laissée vide.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Nombre',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Entrez un numéro valide de 10 chiffres',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Entrer un nombre...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'Préféré?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Accueil',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Entreprise',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'Mobile',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Autre',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Étiquette',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Sélectionnez le numéro à appeler',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Préféré',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'Entrez un numéro valide'
};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-fr.js